import 'leaflet/dist/leaflet.css';
import './ConsoleModemCard.css';
import { memo } from 'react';

interface ConsoleModemCardProps {
    imei: string;
    modemName: string;
    isOnline: boolean;
    isActive: boolean;
    version: number;
    update: number;
    upgrade: boolean;
    isArm: boolean;
    mavType: number;
    onClick: (imei: string) => void;
}

interface IconProps {
    type: number;
}

interface UpdateIconProps {
    version: number;
    update: number;
    upgrade: boolean;
}

const OnlineIcon = memo(({ type }: IconProps) => {
    const src = type === 1 ? '/image/modem/online_plane.svg' : '/image/modem/online.svg';
    return <img className='modem-card-online-icon' src={src} title="Online" alt="" />;
});
OnlineIcon.displayName = 'OnlineIcon';

const OfflineIcon = memo(({ type }: IconProps) => {
    const src = type === 1 ? '/image/modem/offline_plane.svg' : '/image/modem/offline.svg';
    return <img className='modem-card-online-icon' src={src} title="Offline" alt="" />;
});
OfflineIcon.displayName = 'OfflineIcon';

const UpdateIcon = memo(({ version, update, upgrade }: UpdateIconProps) => {
    if (version < 2000) return <div></div>;

    if (upgrade) {
        return (
            <img
                className='modem-card-update-icon'
                src="/image/modem/upgrade.svg"
                title="Требуется обновление"
                width="25px"
                alt=""
            />
        );
    }

    if (update !== 0) {
        return (
            <img
                className='modem-card-update-icon'
                src="/image/modem/update.svg"
                title="Требуется обновление"
                width="25px"
                alt=""
            />
        );
    }

    return <div></div>;
});
UpdateIcon.displayName = 'UpdateIcon';

const areEqual = (prevProps: ConsoleModemCardProps, nextProps: ConsoleModemCardProps): boolean => {
    return (
        prevProps.imei === nextProps.imei &&
        prevProps.isOnline === nextProps.isOnline &&
        prevProps.isActive === nextProps.isActive &&
        prevProps.modemName === nextProps.modemName &&
        prevProps.version === nextProps.version &&
        prevProps.update === nextProps.update &&
        prevProps.upgrade === nextProps.upgrade &&
        prevProps.isArm === nextProps.isArm &&
        prevProps.mavType === nextProps.mavType
    );
};

const ConsoleModemCard = ({
    imei,
    isOnline,
    onClick,
    isActive,
    modemName,
    version,
    update,
    upgrade,
    isArm,
    mavType
}: ConsoleModemCardProps) => {
    const handleClick = () => onClick(imei);

    return (
        <div
            className={`console-modem-card${isActive ? ' console-active-modem-card' : ''}`}
            onClick={handleClick}
        >
            <div className='modem-card-info'>
                <div className='modem-card-name t-normal'>{modemName}</div>
                <div className='modem-card-imei t-normal t-grey'>{imei}</div>
                <div className='modem-card-arm t-big'>{isArm ? 'ARM' : 'DISARM'}</div>
            </div>
            <div className='online-update'>
                <UpdateIcon version={version} update={update} upgrade={upgrade} />
                {isOnline ? <OnlineIcon type={mavType} /> : <OfflineIcon type={mavType} />}
            </div>
        </div>
    );
};

export default memo(ConsoleModemCard, areEqual);